export default class Land {
  // @alican Object freeze und als const
  static get KEYS() {
    return {
      CH: 'CH',
      INTL: 'INTL'
    }
  }

  static get ITEMS() {
    return Object.values(Land.KEYS)
      .map(value => ({
        value: value,
        name: `land.${value}`
      }))
  }
}
